<script setup lang="ts">
import {pagesPath} from '@/ts/router/pages-path';
import {GIT_HASH, SHOW_REVISION} from '@/ts/utils/consts';
import {useRoute} from 'vue-router';
import {computed} from 'vue';

const route = useRoute();
const [interventionRoutePrefix] = pagesPath.intervention.interventionFetch.split(':');
const isOnInterventionRoute = computed(() => {
  return route.path.endsWith(pagesPath.intervention.interventionsList)
    || route.path.includes(interventionRoutePrefix);
});
</script>

<template>
  <router-link :to="pagesPath.main.home" class="header-logo focus-visible" :aria-label="$t('home')">
    <!-- Show medical logo on intervention routes -->
    <template v-if="isOnInterventionRoute">
      <img src="../../../assets/img/balm-medical-logo.svg" class="logo logo-for-light-mode" alt="Balm"/>
      <img src="../../../assets/img/balm-medical-logo-dark.svg" class="logo logo-for-dark-mode" alt="Balm"/>
    </template>
    <!-- Show regular logo elsewhere -->
    <template v-else>
      <img src="../../../assets/img/balm-logo.svg" class="logo logo-for-light-mode" alt="Balm"/>
      <img src="../../../assets/img/balm-logo-for-dark-mode.svg" class="logo logo-for-dark-mode" alt="Balm"/>
    </template>
    <div v-if="SHOW_REVISION" class="git-hash text-body-sm">
      {{ GIT_HASH }}
    </div>
  </router-link>
</template>

<style lang="scss" scoped>

.header-logo {
  position: relative;
  height: 22px;
  

  @include screen-lg {
    height: 22px;
  }
}

.logo {
  height: 22px;

}

.git-hash {
  position: absolute;
  top: 17px;
  left: 0px;
  font-size: 10px;
  color: var(--Neutral-UI-neutral-ui-80);
  width: 200px;
  padding-top: 4px;
}

@include light-mode {
  .logo-for-dark-mode {
    display: none;
  }
}

@include dark-mode {
  .logo-for-light-mode {
    display: none;
  }
}

</style>
